<template>
  <div class="container-fluid desc">
    <SelectItems :items="items" :set="set"></SelectItems>
  </div>
</template>

<script>
  import MenuList from "@/assets/Helper/MenuList";
  import Config from "@/vuex/Config";
  import SelectItems from "@/components/Forms/SelectItems";

  export default {
    name: 'SetOverviewDescription',
    components: {SelectItems},
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
        currentVarType: Config.getters.getLastCurrentVarType
      };
    },
    props: [
      'set'
    ],
    mounted() {
      if (this.$parent.currentNavigation === 'overview' ||
          this.$parent.currentNavigation === 'warehouse'
      ) {
        setTimeout(() => {
          this.$root.$emit('setOverview');
        }, 250);
      }
    },
    methods: {
      configure: function (type) {
        Config.dispatch('setCurrentVarType', type);
      }
    },
    computed: {
      menuList: function () {
        return MenuList.get(this.set.currentItem);
      },
      items: function () {
        return (typeof this.set === "object") ? Array.from(this.set.items.keys()) : [];
      }
    }
  }
</script>

<style lang="scss" scoped>
  #app {
    .desc {
      background-color: $white;
      font-size: 1em;

      .row {
        padding-top: 1em;
        padding-bottom: 1em;
        border-bottom: solid 0.02em $brandDarkGrey;
        cursor: pointer;

        h5 {
          line-height: 2em;
          cursor: pointer;
          color: $brandDarkGrey;
          letter-spacing: 0.1em;
          text-align: center;
          font-weight: normal;
        }
      }

      .row:hover {
        background-color: $lightGreyBg;
      }

      .row.on {
        border-bottom: solid 0.2em $black;

        h5 {
          font-weight: bold;
          color: $fontColor;

        }
      }

      .row:last-child {
        border: none;
      }
    }
  }
</style>
